import moment from 'moment';

import type {Tag} from './tags-editor';

export const getTooltipText = (tag: Tag): string | null | undefined => {
    let creatorText;
    let createdTime;

    if (tag.creator) {
        if (tag.creator.__typename === 'User') {
            creatorText = `Added by ${tag.creator.name}`;
        } else {
            creatorText = `Added via ${tag.creator.name}`;
        }
    }

    if (tag.createdTime) {
        createdTime = moment.unix(tag.createdTime).format('MMM D, YYYY');
    }

    if (creatorText && createdTime) {
        return `${creatorText} on ${createdTime}`;
    } else if (creatorText) {
        return creatorText;
    } else if (createdTime) {
        return `Added on ${createdTime}`;
    } else {
        return null;
    }
};
